var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDioxin03(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 743.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_42",
    "data-name": "Ebene 42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.08,
    y: 716.29,
    width: 2.7,
    height: 22.43,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.38,
    y: 716.29,
    width: 2.7,
    height: 22.43,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,683.58a13.06,13.06,0,0,0,13.05,13.06V670.53A13,13,0,0,0,311,683.58Z",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08,670.53v26.11a13.06,13.06,0,1,0,0-26.11Z",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.08,685.59V729a21.72,21.72,0,0,0,0-43.43Z",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.37,707.3A21.71,21.71,0,0,0,324.08,729V685.59A21.71,21.71,0,0,0,302.37,707.3Z",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.54,
    y: 647.01,
    width: 2.63,
    height: 21.85,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.91,
    y: 647.01,
    width: 2.63,
    height: 21.85,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.82,611c0,9.24,5.7,16.73,12.72,16.73V594.24C367.52,594.24,361.82,601.73,361.82,611Z",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54,594.24V627.7c7,0,12.71-7.49,12.71-16.73S381.56,594.24,374.54,594.24Z",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.54,603.74V659.4c11.68,0,21.14-12.46,21.14-27.83S386.22,603.74,374.54,603.74Z",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.39,631.57c0,15.37,9.47,27.83,21.15,27.83V603.74C362.86,603.74,353.39,616.2,353.39,631.57Z",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.2,
    y: 692.95,
    width: 2.63,
    height: 21.85,
    style: {
      fill: "#a09c8a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.57,
    y: 692.95,
    width: 2.63,
    height: 21.85,
    style: {
      fill: "#dcd8c9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.01 662.14 254.03 702.44 269.2 702.44 269.2 662.14 266.01 662.14",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.37 702.44 272.39 662.14 269.2 662.14 269.2 702.44 269.2 702.44 284.37 702.44",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "268.28 646.88 259.2 677.43 269.2 677.43 269.2 646.88 268.28 646.88",
    style: {
      fill: "#75ad87"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.2 677.43 270.12 646.88 269.2 646.88 269.2 646.88 269.2 677.43 269.2 677.43 279.2 677.43",
    style: {
      fill: "#479260"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.54,
    y1: 738.72,
    x2: 374.54,
    y2: 738.72,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.59,
    y1: 727.79,
    x2: 377.27,
    y2: 120.64,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.939727783203125"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.29,
    y1: 115.17,
    x2: 377.29,
    y2: 115.17,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.35,
    y1: 738.72,
    x2: 353.35,
    y2: 738.72,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 353.4,
    y1: 727.72,
    x2: 355.94,
    y2: 138.79,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.008064270019531"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.97,
    y1: 133.29,
    x2: 355.97,
    y2: 133.29,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.17,
    y1: 738.72,
    x2: 332.17,
    y2: 738.72,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 332.21,
    y1: 727.64,
    x2: 334.62,
    y2: 156.95,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.081558227539062"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.64,
    y1: 151.41,
    x2: 334.64,
    y2: 151.41,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.98,
    y1: 738.72,
    x2: 310.98,
    y2: 738.72,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 311.02,
    y1: 727.78,
    x2: 313.29,
    y2: 175,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,10.946185111999512"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 313.31,
    y1: 169.53,
    x2: 313.31,
    y2: 169.53,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.79,
    y1: 738.72,
    x2: 289.79,
    y2: 738.72,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.84,
    y1: 727.7,
    x2: 291.97,
    y2: 193.16,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.021614074707031"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.99,
    y1: 187.65,
    x2: 291.99,
    y2: 187.65,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.61,
    y1: 738.72,
    x2: 268.61,
    y2: 738.72,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.65,
    y1: 727.62,
    x2: 270.64,
    y2: 211.32,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3,
      strokeDasharray: "0,11.103328704833984"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.66,
    y1: 205.77,
    x2: 270.66,
    y2: 205.77,
    style: {
      fill: "none",
      stroke: "#9bc6de",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.64,
    cy: 247.18,
    r: 30.09,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.05,
    cy: 271.82,
    r: 25.07,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.72,
    cy: 95.79,
    r: 67.35,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.26,
    cy: 47.33,
    r: 40.91,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.41,
    cy: 226.2,
    r: 60.21,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 267.45,
    cy: 139.75,
    r: 103.03,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.02,
    cy: 38.85,
    r: 103.03,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.61,
    cy: 139.99,
    r: 75.01,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.29,
    cy: 183.12,
    r: 81.2,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.34,
    cy: 210.64,
    r: 44.36,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.69,
    cy: 196.68,
    r: 40.83,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 99.64,
    cy: 159.19,
    r: 36.12,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307.26,
    cy: 82.65,
    r: 56.79,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.78,
    cy: 155.37,
    r: 34.12,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.77,
    cy: 235.78,
    r: 12.75,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.52,
    cy: 213.06,
    r: 12.75,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.99,
    y: -11.58,
    width: 399.01,
    height: 39.86,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.2,
    y: 11.5,
    width: 271.8,
    height: 84.29,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.64,
    cy: 68.16,
    r: 14.52,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.49,
    cy: 18.92,
    r: 14.52,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.17,
    cy: 123.61,
    r: 11.74,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.18,
    cy: 155.85,
    r: 11.74,
    style: {
      fill: "#e78d38"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dioxine_OK",
    "data-name": "Dioxine OK"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.36,
    cy: 394.06,
    r: 44.36,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.78,
    cy: 387.13,
    r: 23.07,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.95,
    cy: 508.02,
    r: 8.43,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9,
    cy: 516.93,
    r: 6.44,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.31,
    cy: 525.63,
    r: 6.03,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.3,
    cy: 534.39,
    r: 4.72,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.3,
    cy: 540.66,
    r: 3.39,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.3,
    cy: 545.64,
    r: 2.12,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.28,315.14a23.52,23.52,0,0,1,11.57-2,23.68,23.68,0,0,1,21.63-29.67,38.82,38.82,0,0,1,65.78-35.91A23.75,23.75,0,1,1,256,276.35a38.77,38.77,0,0,1-51.77,34.7,23.74,23.74,0,0,1-25.36,19.82,23.74,23.74,0,1,1-32.61-15.73Z",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.39,
    cy: 312.32,
    r: 56.52,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.87,295.25a23.6,23.6,0,0,0-9.21,7.28,23.66,23.66,0,0,0-36.52-3.81A38.81,38.81,0,0,0,88.42,323.5a23.74,23.74,0,1,0,.66,43.67,23.4,23.4,0,0,0,6.61-4.42,26.93,26.93,0,0,0,47.46-6.66A38.69,38.69,0,0,0,163,335.55a23.75,23.75,0,0,0,31.7-5.54,23.74,23.74,0,1,0,10.16-34.76Z",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.83,199.61a32.74,32.74,0,0,0-12.73,10,32.69,32.69,0,0,0-50.43-5.26A53.6,53.6,0,0,0,110,238.63a32.82,32.82,0,1,0,10,54.2,37.2,37.2,0,0,0,65.54-9.19A53.39,53.39,0,0,0,213,255.27a32.8,32.8,0,0,0,43.78-7.66,32.79,32.79,0,1,0,14-48Z",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.74,
    cy: 493.1,
    r: 11.39,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.7,
    cy: 478.44,
    r: 14,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.46,
    cy: 461.14,
    r: 19.02,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 84.13,
    cy: 440.2,
    r: 22.66,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.78,
    cy: 400.51,
    r: 5.19,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.46,
    cy: 364.45,
    r: 33.5,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.67,
    cy: 392.93,
    r: 11.93,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.49,
    cy: 384.19,
    r: 5.22,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.8,
    cy: 285.67,
    r: 26.77,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.71,
    cy: 320.13,
    r: 17.7,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.08,
    cy: 302.8,
    r: 37.59,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.83,
    cy: 194.33,
    r: 24.5,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.47,
    cy: 203.08,
    r: 7.56,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.12,
    cy: 187.51,
    r: 7.56,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.09,
    cy: 287.1,
    r: 7.56,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.58,
    cy: 243.68,
    r: 7.56,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.35,
    cy: 349.84,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.88,
    cy: 381.05,
    r: 2.4,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.14,
    cy: 427.02,
    r: 2.4,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.89,
    cy: 441.63,
    r: 2.4,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.31,
    cy: 477.63,
    r: 2.4,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.67,
    cy: 281.38,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 270.66,
    cy: 265.65,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 291.35,
    cy: 364.46,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.89,
    cy: 582.97,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 354.76,
    cy: 483.6,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.94,
    cy: 316.67,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 377.29,
    cy: 191.23,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.62,
    cy: 528.36,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 374.15,
    cy: 705.32,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.2,
    cy: 727.9,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.92,
    cy: 356.37,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.92,
    cy: 553.65,
    r: 4.66,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.94 610.67 76.22 610.67 52.9 610.67 52.9 640.06 88.94 640.06 88.94 610.67",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.38 630.99 84.89 624.27 84.89 630.99 65.39 624.27 65.39 630.99 45.9 624.27 45.9 640.06 45.9 652.21 45.9 668.4 104.38 668.4 104.38 652.21 104.38 652.21 104.38 630.99",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.18 610.67 81.69 550 77.39 550 77.39 610.67 83.18 610.67",
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.39 550 73.09 550 71.59 610.67 77.39 610.67 77.39 550",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.96 547.16 72.09 547.16 72.09 550 77.39 550 77.39 547.16 73.96 547.16",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.68 547.16 80.81 547.16 77.39 547.16 77.39 550 82.68 550 82.68 547.16",
    style: {
      fill: "#1d2124"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.39 564.21 82.03 564.21 81.94 560.33 77.39 560.33 77.39 564.21",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.39 588.73 82.64 588.73 81.94 560.33 77.39 560.33 77.39 588.73",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.39,
    y: 554.2,
    height: 3.88,
    style: {
      fill: "#dd642b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.39,
    y: 560.33,
    height: 3.88,
    style: {
      fill: "#dd642b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.39 560.33 72.83 560.33 72.74 564.21 77.39 564.21 77.39 560.33",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.39,
    y: 566.76,
    height: 21.96,
    style: {
      fill: "#dd642b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.39 560.33 72.83 560.33 72.14 588.73 77.39 588.73 77.39 560.33",
    style: {
      fill: "#555"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDioxin03);
export default __webpack_public_path__ + "static/media/dioxin_03.0a9b33d000a2db543489d62c409c0174.svg";
export { ForwardRef as ReactComponent };